import { yo } from 'models/CommentedAnswer';
import Form from './Form';

class ROPA extends Form {
  responsable?: string;
  description?: string;
  area?: string;
  purpose?: string;
  whichData?: string;
  hasAnotherController?: string;
  hasAnotherOperator?: string;
  whichHolders?: string;
  sourceOfData?: string;
  hasDataShare?: string;
  shareWith?: string;
  contractLinkWithOperator?: string;
  sentAbroad?: string;
  custodyTerm?: string;
  securityMeasures?: string;
  baseLegal?: string;
  baseLegalSensitiveData?: string;
  rightGuaranteedHolders?: string;
  automatedDecision?: yo;
  linkConsentRegister?: string;
  storageDataLocation?: string;
  recommendedImpactReport?: yo;
  progressReport?: string;
  linkToReport?: string;
  hasIncident?: yo;
  linkToDocIncident?: string;
}

export default ROPA;
